<template>
  <div>
    <b-row>
      <b-col cols="2" style="padding-right: 0;height: 100vh;overflow-y: auto;max-width: 19%;">
        <SidebarMenu
          :menu="menu"
          :relative="true"
          :width="'15rem'"
          :showOneChild="true"
          :theme="'white-theme'"
        >
          <span slot="dropdown-icon">
            <font-awesome-icon icon="caret-square-down" />
          </span>
        </SidebarMenu>
      </b-col>
      <b-col cols="10" class="p-0">
        <transition name="fade">
          <router-view />
        </transition>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { SidebarMenu } from "vue-sidebar-menu";
// import { Helper } from "../helpers";

// import { HTTP } from "../utils/HTTP";
export default {
  name: "ClientProfilePage",
  components: {
    SidebarMenu
  },
  data() {
    return {
      menu: [
        {
          header: true,
          title: "ClientName",
          hiddenOnCollapse: true
        },
        {
          href: "/client-profile/" + this.$route.params.id + "/overview",
          title: "Overview",
          icon: "fa fa-user"
        },
        {
          href: "/client-profile/" + this.$route.params.id + "/reports",
          title: "Reports",
          icon: "fa fa-chart-area"
        },
        {
          href: "/client-profile/" + this.$route.params.id + "/contacts",
          title: "Contacts",
          icon: "fa fa-chart-area"
        },
        {
          href: "/client-profile/" + this.$route.params.id + "/configuration",
          title: "Configuration",
          icon: "fa fa-chart-area"
        },
        {
          href: "#",
          title: "Third Parties",
          icon: "fa fa-chart-area",
          child: [
            {
              href:
                "/client-profile/" + this.$route.params.id + "/manage-tp-user",
              title: "Manage My TP Page Columns"
            },
            {
              href:
                "/client-profile/" +
                this.$route.params.id +
                "/add-company-keywords",
              title: "Manage Escape Keywords"
            },
            {
              href:
                "/client-profile/" +
                this.$route.params.id +
                "/tpi-custom-attributes",
              title: "Manage Custom Attributes"
            },
            {
              href:
                "/client-profile/" + this.$route.params.id + "/thirdparties",
              title: "All"
            },
            {
              href:
                "/client-profile/" +
                this.$route.params.id +
                "/thirdparties/onboarding",
              title: "Onboarding",
              child: [
                {
                  href:
                    "/client-profile/" +
                    this.$route.params.id +
                    "/thirdparties/onboarding/pre-screening",
                  title: "Pre-Screening"
                },
                {
                  href:
                    "/client-profile/" +
                    this.$route.params.id +
                    "/thirdparties/onboarding/screening",
                  title: "Screening"
                }
              ]
            },
            {
              href:
                "/client-profile/" +
                this.$route.params.id +
                "/thirdparties/approved",
              title: "Approved"
            },
            {
              href:
                "/client-profile/" +
                this.$route.params.id +
                "/thirdparties/archived",
              title: "Archived"
            }
          ]
        },
        {
          href: "#",
          title: "Remediation",
          icon: "fa fa-chart-area",
          child: [
            {
              href: "/client-profile/" + this.$route.params.id + "/remediation",
              title: "Remediation IDD+"
            },
            {
              href: "/client-profile/" + this.$route.params.id + "/identifiers",
              title: "Identifiers "
            }
          ]
        },
        {
          href: "/client-profile/" + this.$route.params.id + "/forms",
          title: "Forms",
          icon: "fa fa-chart-area"
        },
        {
          href: "/client-profile/" + this.$route.params.id + "/edd",
          title: "EDD",
          icon: "fa fa-chart-area"
        },
        {
          href: "/client-profile/" + this.$route.params.id + "/vouchers",
          title: "Vouchers",
          icon: "fa fa-chart-area"
        },
        {
          href: "/client-profile/" + this.$route.params.id + "/manage-category",
          title: "Manage Category",
          icon: "fa fa-chart-area"
        },
        {
          href: "#",
          title: "Users",
          icon: "fa fa-chart-area",
          child: [
            {
              href:
                "/client-profile/" + this.$route.params.id + "/manage-users",
              title: "Manage Users"
            },
            {
              href: "/client-profile/" + this.$route.params.id + "/add-user",
              title: "Add User"
            }
          ]
        },
        {
          href: "#",
          title: "Training & Exams",
          icon: "fa fa-chart-area",
          child: [
            {
              href:
                "/client-profile/" +
                this.$route.params.id +
                "/training/courses",
              title: "Courses"
            },
            {
              href:
                "/client-profile/" + this.$route.params.id + "/training/exams",
              title: "Exams"
            },
            {
              href:
                "/client-profile/" +
                this.$route.params.id +
                "/training/exam-questions",
              title: "Exams Questions"
            }
          ]
        },
        {
          href: "#",
          title: "Workflow",
          icon: "fa fa-chart-area",
          child: [
            {
              href:
                "/client-profile/" + this.$route.params.id + "/workflow/types",
              title: "Types"
            },
            {
              href:
                "/client-profile/" + this.$route.params.id + "/workflow/stages",
              title: "Stages"
            },
            {
              href:
                "/client-profile/" + this.$route.params.id + "/workflow/forms",
              title: "Forms"
            }
          ]
        },
        {
          href: "#",
          title: "Control Group",
          icon: "fa fa-chart-area",
          child: [
            {
              href:
                "/client-profile/" +
                this.$route.params.id +
                "/control-group-categories",
              title: "Control Groups"
            },
            {
              href:
                "/client-profile/" +
                this.$route.params.id +
                "/control-group-categories-population",
              title: "Control Groups Population"
            }
          ]
        }
      ]
    };
  },
  computed: {},
  methods: {},
  mounted() {}
};
</script>

<style scoped>
</style>
